export default "__VITE_ASSET__BaJWIWfX__"